import { configureStore } from '@reduxjs/toolkit'
import school from './schools/slice';
import logger from 'redux-logger';

export const store = configureStore({
  reducer: {
    school
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(logger)
})


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/letera/src/features/store.js